import React from "react"

const  CallMe = ({ className: styledClassName, children, ...props }) => {

    return <div className={`${styledClassName}`}>
        <span>Call me </span>
    </div>
}

export default  CallMe